// Figma "cases" > DEPT Festival 2019, section 55:1253, frames in screen order:
// 55:1254 (cover), 55:1294, 55:1322, 55:1349, 55:1406 (+ section layer 55:1457 "BREAKS 1"), 55:1430, 55:1379
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/dept-festival/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const IMG = own

export const deptFestival: Case = {
    name: "DEPT Festival 2019",
    theme: {
        page: "#1b0d6b",
        gradient: "linear-gradient(180deg, #1b0d6b 0%, #341ad1 100%)",
        stops: [
            [27, 13, 107, 0],
            [52, 26, 209, 1],
        ],
        fill: "#0033ff",
        line: "#0073ff",
        tone: "dark",
        title: "#ffffff",
        body: "rgba(255, 255, 255, 0.6)",
    },
    modules: [
        // 1: a brick layout: the top photo (888 wide) spans the card's column and
        // half of the next; the bottom photo (887) starts under its middle, as
        // high as the card beside it. Columns at the cells' edges: 220, 443, 442, 443.
        {
            type: "bricks",
            cols: [220, 443, 442, 443],
            rows: [443, 400],
            cells: [
                {
                    at: [0, 0],
                    h: 220,
                    tag: {
                        logo: "/work/dept-festival/logo.svg",
                        logoBox: [20, 20, 33, 45],
                        text: "DEPT (FESTIVAL)\nTECH & MARKETING AGENCY\nFOUNDED 1997\n\nVARIOUS TOUCHPOINTS",
                        color: "#000000",
                    },
                },
                { at: [1, 0, 2], h: 443, image: IMG("1-1", 1776, 886) },
                {
                    at: [1, 1],
                    h: 400,
                    card: {
                        title: "Dept Agency's\nyearly festival",
                        body: "The festival is the epicenter of the latest trends in creativity, data, and technology, all in one day filled with talks and other events. This collection shows the process from first concepts to final execution.",
                    },
                },
                { at: [2, 1, 2], h: 400, image: IMG("1-2", 1774, 800), phone: false },
            ],
        },
        // 2: wide image left 1332 + "early concepts" block right 220
        {
            type: "grid",
            columns: [
                { w: 1332, cells: [{ h: 846, image: IMG("2-1", 2664, 1692) }] },
                { w: 220, cells: [{ h: 220, tag: { text: "EARLY CONCEPTS" } }, { h: 626 }] },
            ],
        },
        // 3: square-ish image left 663 (on black) + wide right 888
        {
            type: "grid",
            columns: [
                { w: 663, cells: [{ h: 652, image: IMG("3-1", 1326, 1304) }, { h: 191 }] },
                { w: 888, cells: [{ h: 846, image: IMG("3-2", 1776, 1692) }] },
            ],
        },
        // 4: "final form" block 220 + three tall images (designed 451/452/451, which ran
        // 28px past the content area; cropped to fit, centred)
        {
            type: "grid",
            columns: [
                { w: 220, cells: [{ h: 220, tag: { text: "FINAL FORM" } }, { h: 626 }] },
                { w: 443, cells: [{ h: 846, image: IMG("4-1", 886, 1692) }] },
                { w: 442, cells: [{ h: 846, image: IMG("4-2", 884, 1692) }] },
                { w: 443, cells: [{ h: 846, image: IMG("4-3", 886, 1692) }] },
            ],
        },
        // 5: one full video
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: { id: "/work/dept-festival/c-breaks", src: "/work/dept-festival/c-breaks", w: 1920, h: 1044, widths: [800, 1600, 1920] }, clip: { src: "/work/dept-festival/c-breaks" } }] }] }, // video: node 55:1457 "BREAKS 1", glitchy orange/blue/black stripes with "DEPT FESTIVAL 2019" in white
        // 6: wide image left 888 + right column: image 666 x 422 over a narrower 443 x 422
        {
            type: "grid",
            columns: [
                { w: 888, cells: [{ h: 846, image: IMG("6-1", 1776, 1692) }] },
                {
                    w: 666,
                    cells: [
                        { h: 422, image: IMG("6-2", 1332, 844) },
                        { h: 422, w: 443, image: IMG("6-3", 886, 844) },
                    ],
                },
            ],
        },
        // 7: image left 776 + right column of two images 365 and 478 high
        {
            type: "grid",
            columns: [
                { w: 776, cells: [{ h: 846, image: IMG("7-1", 1552, 1692) }] },
                {
                    w: 776,
                    cells: [
                        { h: 365, image: IMG("7-2", 1552, 730) },
                        { h: 478, image: IMG("7-3", 1552, 956) },
                    ],
                },
            ],
        },
    ],
}
